module.exports = __webpack_public_path__ + "static/media/instagram.4a3326d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/instagram.svg
// module id = 220
// module chunks = 0